<div style="padding:30px">
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer"  (click)="choose(item.id)">
            <span  [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>

    <div *ngIf="now=='0' && isActive">
        <highcharts-chart [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="areaOptions" style="display: block;width: 70%;margin:10px"></highcharts-chart>
    </div>
    <div *ngIf="now=='1' && isActive">
        <highcharts-chart [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="areaOptions" style="display: block;width: 70%;margin:10px"></highcharts-chart>

    </div>
    <div *ngIf="now=='2' && isActive">
        <highcharts-chart [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="areaOptions" style="display: block;width: 70%;margin:10px"></highcharts-chart>

    </div>
</div> 